var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',{ref:"form",attrs:{"autocomplete":_vm.autocomplete ? 'on' : 'off',"name":_vm.name},on:{"submit":function($event){$event.preventDefault();return _vm.send.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }